import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import { loadPageTranslations } from './i18n.js';

loadPageTranslations(window.location.pathname).then(
    () =>
        startTransition(() => {
            hydrateRoot(
                document,
                <StrictMode>
                    <HydratedRouter />
                </StrictMode>,
            );
        }),
    (error) => console.error('Could not load the page translations; the page stays as prerendered', error),
);
